import { SearchBox as SearchBoxController } from "@coveo/headless";
import React, { FunctionComponent, useEffect, useState } from "react";
import { AutoComplete } from "./AutoComplete";

interface SearchBoxProps {
  controller: SearchBoxController;
  onSearchSubmit: (value: string) => void;
  placeholder?: string;
  inputClassName?: string;
}

const SearchBox: FunctionComponent<SearchBoxProps> = ({
  controller,
  onSearchSubmit,
  placeholder,
  inputClassName,
}) => {
  const [state, setState] = useState(controller.state);

  useEffect(() => {
    controller.showSuggestions();
    return controller.subscribe(() => setState(controller.state));
  }, [controller]);

  return (
    <AutoComplete
      value={state.value}
      onChange={(value) => controller.updateText(value)}
      suggestions={state.suggestions.map((item) => item.rawValue)}
      onSubmit={onSearchSubmit}
      placeholder={placeholder}
      inputClassName={inputClassName}
    />
  );
};

export default SearchBox;
